import { Paper } from "@mui/material";
import React from "react";
import BarraTitulo from "./BarraTitulo";
import Template from "./Template";

export default function TemplateBase(props) {
  return (
    <Template {...props}>
      <BarraTitulo {...props} />

      <Paper>{props.children}</Paper>
    </Template>
  );
}
